<template>
    <nav id="sidebar" class="">
        <ul class="list-unstyled sidebar-menu components mb-5">
            <li :class="{ active: menu_active == 'home' }">
                <router-link :to="{ name: 'home' }" @click.native="getSoundClick">
                    <i class="ito-icon ito-home"></i>{{ $t('menu_item_home') }}
                </router-link>
            </li>

            <li class="live-class-menu" :class="{ active: menu_active == 'live_class', disable: lock_features.includes('live_class') }" v-if="user_info.account_live_class == 1">
                <router-link :to="{ name: 'live_class' }" @click.native="getSoundClick">
                    <i class="ito-icon ito-live-class"></i>{{ $t('live_class') }}
                </router-link>
                <div class="live-class-alert" v-if="live_class && user_info.student_type == 1 && menu_active != 'live_class'">
                    <div class="live-class-alert-title">{{ $t('class') }}: {{ live_class.class_name }}</div>
                    <p>{{ $t('subject') }}: {{ live_class.subject }}</p>
                    <p class="live-class-text"><span class="live-class-dot"></span>{{ $t('live_now') }}</p>
                    <router-link :to="{name: 'live_class'}" class="ito-btn ito-btn-block ito-btn-sm ito-btn-success mt-3">
                        {{ $t('join_to_class') }}
                    </router-link>
                </div>
            </li>

            <li :class="{ active: menu_active == 'daily_challenge' || menu_active == 'daily_bonus' || menu_active == 'achievement', disable: lock_features.includes('mission') }">
                <router-link :to="lock_features.includes('mission') ? '' : { name: 'daily_challenge' }" :class="{ has_noti: (user_info.dailychallenge_noti != 0 || user_info.first_login == 1 || user_info.count_achieve_unread > 0) }"
                    @click.native="getSoundClick">
                    <i class="ito-icon ito-missions"></i>{{ $t('menu_item_achievements') }}
                </router-link>
            </li>

            <li :class="{ active: menu_active == 'events', disable: lock_features.includes('events') }">
                <router-link :to="lock_features.includes('events') ? '' : { name: 'events' }" @click.native="getSoundClick">
                    <i class="ito-icon ito-events"></i>{{ $t('menu_item_events') }}
                </router-link>
            </li>

            <li
                :class="{ active: menu_active == 'parent_report' || menu_active == 'parent_feedback' || menu_active == 'parent_account' || menu_active == 'parent_certificate' || menu_active == 'parent_daily_comment', disable: lock_features.includes('parents') }">
                <router-link :to="lock_features.includes('parents') ? '' : { name: 'parent_report' }" @click.native="getSoundClick">
                    <i class="ito-icon ito-parents"></i>{{ $t('menu_item_parents') }}
                </router-link>
            </li>

            <li :class="{ active: menu_active == 'your_space_trophies' || menu_active == 'your_space_badges' || menu_active == 'your_space_certificates', disable: lock_features.includes('your_space') }">
                <router-link :to="lock_features.includes('your_space') ? '' : { name: 'your_space_trophies' }" :class="{ has_noti: user_info.trophy_unread != 0 }" @click.native="getSoundClick">
                    <i class="ito-icon ito-your-space"></i>{{ $t('menu_item_your_space') }}
                </router-link>
            </li>

        </ul>
    </nav>
</template>

<script>
import axios from 'axios'
import { soundClick } from '../utils/utils'
import { getLiveClass } from '../models/dashboard'
import router from '@/router'

export default {
    name: "SideBar",
    data() {
        const lock_feature = this.$store.state.user_info.lock_feature ? Array.prototype.map.call(this.$store.state.user_info.lock_feature, (x) => x.name) : [];
        return {
            menus: [],
            lock_features: lock_feature
        };
    },
    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
        menu_active() {
            return this.$route.name;
        },
        live_class: function () {
            const live_classes = this.$store.state.live_classes || []
            return live_classes.find(live_class => live_class.is_live == 1) || undefined;
        }
    },
    methods: {
        getSoundClick() {
            soundClick();
        },
        onLogout(e) {
            this.$store.dispatch('logout').then(() => {
                window.location.href = "/login";
            });
            e.preventDefault();
        },
    },
    components: { router }
}
</script>

<style scoped>
/*sidebar*/

#sidebar {
    position: sticky;
    top: 0;
    width: 100px;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    background: var(--primary);
    z-index: 1;
}

#sidebar .sidebar-menu {
    position: sticky;
    /* top: 80px; */
    padding-right: 10px;
    width: 110px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 15px;
}

#sidebar ul li {
    width: 110px;
    padding-right: 10px;
    border-radius: 0px 16px 16px 0px;
    min-height: 96px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    transition: all ease-out .2s;
}

#sidebar ul li a {
    position: relative;
    width: 100%;
    display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    letter-spacing: 0.24px;
    color: var(--white);
    transition: all 0.4s;
    overflow: hidden;
}

#sidebar ul li a.has_noti::after {
    content: '';
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #FA450F;
    border: 2px solid #ffffff;
    pointer-events: none;
    bottom: 2px;
    left: 80%;
}

#sidebar ul li.active,
#sidebar ul li:hover {
    background: var(--yellow);
    box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.30) inset;
}

#sidebar ul li.active a,
#sidebar ul li:hover a {
    font-weight: 700;
}

#sidebar ul li.disable::after {
    position: absolute;
    /* top: 0; */
    left: 0;
    content: '';
    z-index: 1;
    width: 100px;
    height: 100px;
    cursor: not-allowed;
    background-image: url('/themes/ito/images/icons/icon-lock-new.svg');
    background-repeat: no-repeat;
    background-position: 34px 25px;
    background-size: 32px 32px;

}

#sidebar ul li.disable,
#sidebar ul li.disable:hover {
    background: none;
    box-shadow: none;
    cursor: not-allowed;
}

#sidebar ul li.disable a,
#sidebar ul li.disable:hover a {
    font-weight: normal;
}

#sidebar ul li.disable a {
    opacity: 0.6;
}


.live-class-menu {
    position: relative;
}

.live-class-alert {
    display: block !important;
    position: absolute;
    top: 0;
    left: 105px;
}

.live-class-alert::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    margin-left: -12px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent #fff transparent transparent;
}
</style>